export { default } from './chosen-bank-info';
